<template>
  <!-- //Remarks -->
  <div id="adviceRemark" class="advice-point" v-if="data.questions">
    <div class="my-3">
      <h3 class="text-xl text-orange-400">{{ questionsTitle | cleanHtml }}</h3>
      <div v-if="data.sections && data.sections.length > 0">
        <div v-for="(section, index) in data.sections" :key="index" class="px-4 my-4">
          <span class="text-l font-semibold" v-if="questionsFiltered(section.id).length > 0">{{ section.name }}</span>

          <ol>
            <li v-for="(question, index) in questionsFiltered(section.id)" :key="index" class="pt-2">      
            <div class="w-full min-h-20 my-3 flex">        
            <div class="w-20 flex-col-center">
              <div v-if="question.question" class="h-11 w-11 mx-auto flex-col-center text-center bg-orange-400 rounded-sm">
                <span class="text-l font-semibold">{{ index + 1 }}</span>
              </div>
            </div>
             <div v-if="question.question" class="w-full p-4 flex-col-center">
            - {{ question.question }}
            </div>
            </div>
            <div v-if="question.task" class="w-full p-4 flex-col-center bg-gray-200 rounded">
              <span class="text-l font-semibold">{{ question.task }}</span>
            </div>
          </li>
          </ol>
        </div>
      </div>

      <div v-else class="p-4">
        <ol>
          <li v-for="(question, index) in data.questions.questions" :key="index" class="pt-2">- {{ question.question }}
          </li>
        </ol>
      </div>
      <p class="mt-5" v-if="note">{{ note | cleanHtml }}</p>
    </div>
  </div>
</template>

<script>
// import ProgressBar from "@/components/ProgressBar.vue";
export default {
  name: "AdviceRemark",
  props: {
    data: Object,
    note: String
  },
  methods: {
    questionsFiltered(idSection) {
      return this.data.questions.questions.filter(
        question => question.idsection == idSection
      );
    }
  },
  computed: {
    questionsTitle() {
      return this.data.questions.content;
    }
  },
  filters: {
    cleanHtml: function (value) {
      if (!value) return "";
      value = value.toString();
      let first = value.indexOf(">") + 1;
      let next = value.indexOf("</");
      return value.substring(first, next);
    }
  }
};
</script>